// extracted by mini-css-extract-plugin
module.exports = {"tagline":"LogoStuff_tagline__NiLKG","brandName":"LogoStuff_brandName__3VUNA","vert-move":"LogoStuff_vert-move__244Vy","mover":"LogoStuff_mover__1CoVm"};